'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z' });

var BorderAll = function BorderAll(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

BorderAll = (0, _pure2.default)(BorderAll);
BorderAll.muiName = 'SvgIcon';

exports.default = BorderAll;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/BorderAll.js
// module id = 2181
// module chunks = 0